/*<!-- ============================================================================= -->
<!-- Alfinet Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->*/


$(document).ready(function() {
    // // Select all elements you want to transform
    // const uppercased = document.querySelectorAll('.capitalize-text');

    // // Iterate through the uppercased and convert their content to lowercase
    // uppercased.forEach(element => {
    //     element.textContent = element.textContent.toLowerCase();
    // });

    function copyToClipboard(element) {
        var oldValue = $(element).html();

        navigator.clipboard.writeText(oldValue);

        $(element).html("COPIADO!");
        setTimeout(function () {
        $(element).html(oldValue);
        }, 1000);
    }

    $(document).on("click", "cupom", function (e) {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboard(this);
    });

    let sliderMenuCollection;

    $('[data-open-sidebar]').on('click', function() {
        $('.page-sidebar, .page-content').toggleClass('sidebar-open');
        $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
    });

    function slidesDesktop() {

        sliderMenuCollection = new Swiper(".slider-collection-menu", {
            slidesPerView: 6.3,
            spaceBetween: 30,
            freeMode: true,
            mousewheel: true,
            pagination: {
            el: ".slider-collection-menu .swiper-pagination",
            type: "progressbar",
            },
            navigation: {
            nextEl: ".slider-collection-menu .swiper-button-next",
            prevEl: ".slider-collection-menu .swiper-button-prev",
            },
        });

        if($('.slider-home').length) {
            sliderHome = new Swiper(".slider-home", { 
                effect: "creative",
                loop: true,
                autoHeight: true,
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                },
                //mousewheel: true,
                keyboard: true,
            });
        };

        if($('.stories-slide').length){
            stories = new Swiper(".stories-slide", {
                slidesPerView: "auto",
                spaceBetween: 16,
                centerInsufficientSlides: true,
                loop: true,
                breakpoints: {
                    1024: {
                        slidesPerView: "auto",
                        spaceBetween: 16
                    }
                }
            });
        }
    }

    slidesDesktop();
});

if ($(window).width() <= 767) {
  $('.slider-collection-menu.swiper-initialized').each(function () {
    this.swiper.destroy(true, true);
  });
}

$(window).on("resize", function () {
  if ($(window).width() <= 767) {
    $('.slider-collection-menu.swiper-initialized').each(function () {
      this.swiper.destroy(true, true);
    });
  } else {
    slidesDesktop();
  }
});

(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__label")) {
        const target = e.target;
        const parentFieldset = target.closest("fieldset");
        parentFieldset
          .querySelector("label.checked")
          ?.classList.remove("checked");
        target.classList.add("checked");

        const compreJunto = target.closest(".product-item--compre-junto");
        const form = target.closest(".card-quickbuy--form");

        const isKit = compreJunto
          ? JSON.parse(compreJunto.dataset.variantIds).length == 2
          : form?.classList.contains("card-quickbuy--kit");

        const isSoldout = compreJunto
          ? compreJunto.querySelectorAll(
              ".card-quickbuy__label.soldout.checked"
            ).length > 0
          : target.classList.contains("soldout");

        // Lógica do quickbuy para o módulo de compre junto
        if (compreJunto) {
          // Desabilita o card de produto caso algum item selecionado esteja soldout
          const addButton = compreJunto.querySelector(".card-product__add-button");

          if (
            (isSoldout && compreJunto.classList.contains("checked")) ||
            (!isSoldout && !compreJunto.classList.contains("checked"))
          ) {
            $(addButton).trigger("click");
          }

          const fieldset = target.closest("fieldset");
          const variantIds = JSON.parse(compreJunto.dataset.variantIds);
          
          const variantIdsNew = variantIds.map(v => {
            if(fieldset.dataset.kit == v.kit || (variantIds.length == 1)) {
              return {
                ...v,
                id: parseInt(target.dataset.variantId)
              }
            }
            return v;
          })    

          compreJunto.setAttribute('data-variant-ids', JSON.stringify(variantIdsNew))
        } else {
          const submitButton = form.querySelector(".card-quickbuy__submit");
          if (submitButton) {
            if (!isKit) {
              if (isSoldout) {
                submitButton.textContent = window.card_soldout;
                submitButton.disabled = true;
              } else {
                submitButton.textContent = window.card_add_to_cart;
                submitButton.disabled = false;
              }

              $(submitButton).show();
            } else {
              const fieldsets = form.querySelectorAll("fieldset");
              const selectedRadios = form.querySelectorAll("label.checked");

              let isSoldout = false;
              if (selectedRadios.length == fieldsets.length) {
                selectedRadios.forEach((radio) => {
                  if (radio.classList.contains("soldout")) {
                    isSoldout = true;
                  }
                });

                if (isSoldout) {
                  submitButton.textContent = window.card_soldout;
                  submitButton.disabled = true;
                } else {
                  submitButton.textContent = window.card_add_to_cart;
                  submitButton.disabled = false;
                }

                $(submitButton).show();
              }
            }
          }
        }
      }
    });

    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__submit")) {
        const submitButton = e.target;
        e.preventDefault();
        submitButton.disabled = true;
        const form = submitButton.closest(".card-quickbuy--form");
        const isKit = form.classList.contains("card-quickbuy--kit");
        let formData = { items: [] };

        if (!isKit) {
          const input = form.querySelector("label.checked");
          const isSoldout = input.classList.contains("soldout");

          if (!isSoldout) {
            formData.items.push({ id: input.dataset.variantId, quantity: 1 });
          }
        } else {
          const fieldsets = form.querySelectorAll("fieldset");
          const inputs = form.querySelectorAll("label.checked:not(.soldout)");

          if (inputs.length == fieldsets.length) {
            inputs.forEach((input) => {
              formData.items.push({ id: input.dataset.variantId, quantity: 1 });
            });
          }
        }

        if (formData.items.length > 0) {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              Shopify.getCart((cart) => {
                window.updateCart(cart);
              });
              submitButton.disabled = false;
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    });
  });
})(jQuery);

